/**
 * BSO — Scroll affordance for horizontally scrollable variant swatches.
 *
 * Drives two CSS custom properties (--fade-l / --fade-r) on any
 * `.block-swatch-list--size` element so an edge-fade mask appears only on the
 * side that has hidden content, and only while the list actually overflows.
 *
 * Progressive enhancement: the CSS defaults both vars to 0px (no fade), so if
 * this script never runs the swatches simply render normally.
 */
(function () {
  if (window.__bsoSwatchScrollHint) return;
  window.__bsoSwatchScrollHint = true;

  var FADE = '28px';
  var THRESHOLD = 2; // px tolerance for start/end detection

  function update(el) {
    var max = el.scrollWidth - el.clientWidth;
    var scrollable = max > 4;
    var atStart = el.scrollLeft <= THRESHOLD;
    var atEnd = el.scrollLeft >= max - THRESHOLD;

    el.style.setProperty('--fade-l', scrollable && !atStart ? FADE : '0px');
    el.style.setProperty('--fade-r', scrollable && !atEnd ? FADE : '0px');
  }

  function init(el) {
    if (el.__scrollHintInit) return;
    el.__scrollHintInit = true;

    var onScroll = function () { update(el); };
    el.addEventListener('scroll', onScroll, { passive: true });

    // Recompute when the list resizes or first becomes visible
    // (variant-image swaps, quick-buy drawer opening, orientation change).
    if ('ResizeObserver' in window) {
      new ResizeObserver(onScroll).observe(el);
    } else {
      window.addEventListener('resize', onScroll);
    }

    update(el);
  }

  function scan(root) {
    (root || document)
      .querySelectorAll('.block-swatch-list--size')
      .forEach(init);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    scan();

    // Catch lists injected after load (quick-buy drawer/popover,
    // Section Rendering API updates).
    if (!('MutationObserver' in window) || !document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('.block-swatch-list--size')) {
            init(node);
          }
          if (node.querySelectorAll) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
